import { REDUCERS } from '../../constants/reducers';

const initialState = {
  loading: false,
  invoices: []
};

const invoice = (state = initialState, action) => {
  switch (action.type) {
    case REDUCERS.INVOICES.SET_INVOICES:
      return {
        ...state,
        invoices: action.value
      };

    case REDUCERS.INVOICES.SET_INVOICES_LOADING:
      return { ...state, loading: action.value };

    case REDUCERS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default invoice;
